import { getNode, setupResizeHandler } from './utils';
import './scss/_colorslegend.scss';

const template = `
    <div class="tsg-colorslegend">
      <div class="tsg-colorslegend__title"></div>
      <div class="tsg-colorslegend__items"></div>
    </div>
`;

class ColorsLegend {
  constructor(container, options) {
    this.container = getNode(container);
    this.options = { type: 'discrete', ...options };
    this.setupHTML();
    this.setupResize();
  }

  setupHTML() {
    this.container.classList.add(`tsg-colorslegend--${this.options.type}`);
    this.container.innerHTML = template;

    this.elems = {
      main: this.container.querySelector('.tsg-colorslegend'),
      title: this.container.querySelector('.tsg-colorslegend__title'),
      items: this.container.querySelector('.tsg-colorslegend__items'),
    };

    if (this.options.title) this.elems.title.innerHTML = this.options.title;

    this.drawItems();
  }

  drawItems() {
    const { items, nullItem, type } = this.options;

    console.log(items, nullItem, type);

    const targetItems = type === 'continuous' ? [] : items;
    const fullItemsList = nullItem ? [...targetItems, nullItem] : targetItems;


    if (type === 'continuous') {
      // fu;

      const e = document.createElement('div');
      e.classList.add('tsg-colorslegend__item');
      const gradientStr = items.map((item, i) => `${item.color} ${100 * i / (items.length - 1)}%`).join(', ');
      console.log(gradientStr);
      e.style.background = `linear-gradient(90deg, ${gradientStr})`;

      const l = document.createElement('div');
      l.classList.add('tsg-colorslegend__label');
      l.innerHTML = items[0].label || '';
      e.appendChild(l);

      const la = document.createElement('div');
      la.classList.add('tsg-colorslegend__label');
      la.classList.add('tsg-colorslegend__label--after');
      la.innerHTML = items[items.length - 1].label;
      e.appendChild(la);

      this.elems.items.append(e);
    }

    fullItemsList.forEach((item) => {
      const isNullItem = item === nullItem;
      const e = document.createElement('div');
      e.classList.add('tsg-colorslegend__item');
      e.style.backgroundColor = item.color;

      const l = document.createElement('div');
      l.classList.add('tsg-colorslegend__label');
      if (isNullItem) {
        e.classList.add('tsg-colorslegend__item-null');
        l.classList.add('tsg-colorslegend__null');
      }
      l.innerHTML = item.label || '';
      e.appendChild(l);

      if (item.labelAfter) {
        const la = document.createElement('div');
        la.classList.add('tsg-colorslegend__label');
        la.classList.add('tsg-colorslegend__label--after');
        la.innerHTML = item.labelAfter;
        e.appendChild(la);
      }

      this.elems.items.append(e);
    });
  }

  updateItems(items) {
    this.options = {
      ...this.options,
      items,
    };

    this.elems.items.innerHTML = '';
    this.drawItems();
  }

  setupResize() {
    setupResizeHandler(this.container, 1, () => {
      const fullWidth = this.container.getBoundingClientRect().width >= window.innerWidth - 10;
      this.elems.main.classList.toggle('tsg-colorslegend--fullwidth', fullWidth);
    });
  }
}

export default ColorsLegend;
